import React, {Component} from 'react';
import {connect} from 'react-redux';
import config from './../../config';
import MoreMenu from './../../components/onboarding/MoreMenu';
import AutoCompleteTeam from './../../components/onboarding/AutoCompleteTeam';
import NextBtn from './../onboarding/NextBtn';

class ManageTeamStatus extends Component {
    triggerPrev = (e, mode) => {
        e.stopPropagation();
        this.props.handleNext('cancel');
    };
    handleNext = (btnType) => {
        this.props.handleNext(btnType);
    };

    render() {
        const {trans, manageTeamMode, hideAutocomplete} = this.props;
        let buttonTypes = null;
        let nextBtnProps = {};
        let cancelBtnProps = {};
        if (manageTeamMode === config.modes["transfer"]) {
            cancelBtnProps = {
                isDisabled : false,
                showTitle  : this.props.isDisabled,
                tooltipText: trans.cancel,
                isNoBorder : true,
                text       : trans.cancel,
                handler    : () => this.handleNext("cancel"),
            };
            nextBtnProps = {
                isDisabled : this.props.isDisabled,
                showTitle  : this.props.isDisabled,
                tooltipText: trans.next,
                text       : trans.next,
                handler    : () => this.handleNext("next"),
            };
            if (!config.isMobile) {
                buttonTypes = <div className="si-subs-mode-btn si-flexBox">
                    <NextBtn {...cancelBtnProps} />
                    <NextBtn {...nextBtnProps} />
                </div>;
            }
        } else if (manageTeamMode === config.modes["transfer-summary"]) {
            cancelBtnProps = {
                isDisabled : false,
                showTitle  : this.props.isDisabled,
                tooltipText: trans.cancel,
                isNoBorder : true,
                text       : trans.cancel,
                handler    : () => this.handleNext("cancel"),
            };
            nextBtnProps = {
                isDisabled : false,
                showTitle  : this.props.isDisabled,
                tooltipText: trans.confirm,
                text       : trans.confirm,
                handler    : () => this.handleNext("confirm"),
            };
            if (!config.isMobile) {
                buttonTypes = <div className="si-subs-mode-btn si-flexBox">
                    <NextBtn {...cancelBtnProps} />
                    <NextBtn {...nextBtnProps} />
                </div>;
            }
        }
        return <div className="si-transfers-header si-flexBox">
            <div className="si-back-btn si-cols">
                <i className="icon-ucl-back_arrow"
                   onClick={(e) => this.triggerPrev(e, config.modes["view-manage-team"])}/>
            </div>
            <div className="si-cols si-header-txt">
                <span>{trans.transfers}</span>
            </div>
            <div className="si-common-menu">
                {!hideAutocomplete ? <AutoCompleteTeam/> : null}
                <MoreMenu/>
            </div>
            {buttonTypes}
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans         : state.appData.trans,
        manageTeamMode: state.formationData.manageTeamMode,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(ManageTeamStatus);


// WEBPACK FOOTER //
// ./src/components/manage-team/Manage-Team-Status.js